var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"contextMenu",staticClass:"context-menu",style:({
    left: (_vm.x + "px"),
    top: (_vm.y + "px")
  }),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }